module.exports = __webpack_public_path__ + "img/illustration-dining.8d91f740.svg";